var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#8E96A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.71 15.0401C29.1 14.6501 29.1 14.0001 28.71 13.6301L26.37 11.2901C26 10.9001 25.35 10.9001 24.96 11.2901L23.12 13.1201L26.87 16.8701M11 25.2501V29.0001H14.75L25.81 17.9301L22.06 14.1801L11 25.2501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditCircle);
export default __webpack_public_path__ + "static/media/icon_edit_circle.da570c2cbe7f8b3d098102ba6f82a57d.svg";
export { ForwardRef as ReactComponent };